/**
 * @generated SignedSource<<6fd908a23992b20ec9cb063c69721e29>>
 * @relayHash 12833661178f357455e63b7f1889f6b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 48326fe7524ab580aea20fefc1445c4adfaf1d1faf4d2e67caa066cdccb48ddc

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueCreated_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueCreated_Subscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProject: {
      readonly issueId: string;
      readonly key: string;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueCreated_Subscription = {
  response: realtimeUpdater_issueCreated_Subscription$data;
  variables: realtimeUpdater_issueCreated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "projectId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "issueId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "onIssueCreatedByProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "onIssueCreatedByProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "48326fe7524ab580aea20fefc1445c4adfaf1d1faf4d2e67caa066cdccb48ddc",
    "metadata": {},
    "name": "realtimeUpdater_issueCreated_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "2c08ad5935c6137cbb2614df040b9574";

export default node;
